//Enach.tsx

import NachWrapper from 'features/nach/components/NachWrapper';
import BankDetails from './BankDetails';
import { Button, Form, message } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import useRazorpay, { RazorpayOptions } from 'react-razorpay';
import {
  getNachMandateDetailsResponseData,
  nachBankDetailType,
  nachRequestType,
  razorpayNachSetup,
  waitingRazorpayOrder,
  waitingRequestType,
} from 'api/nach';
import { useNavigate } from 'react-router-dom';
import { customer_routes } from '../routes';
import Loading from 'features/nach/components/Loading';
import { getTodayTo25YearsTimestamp } from 'features/nach/utils/getTimestamp';

type Props = {
  bankData: nachBankDetailType;
  mandateLinkData: getNachMandateDetailsResponseData;
  mandateId: string;
};

function Enach({ bankData, mandateLinkData, mandateId }: Props) {
  const [form] = Form.useForm();
  const [Razorpay] = useRazorpay();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [enachBankCode, setEnachBankCode] = useState<string | undefined>(undefined);
  const [branchName, setBranckName] = useState<string | undefined>(undefined);
  const [paymentTimeoutId, setPaymentTimeoutId] = useState<NodeJS.Timeout | null>(null); // Timer state

  // const [showRazorpay, setShowRazorpay] = useState(false);
  // console.log('Payment timeout id', paymentTimeoutId);
  // 🔄 FIX: Watch fields dynamically on every keystroke
  const formValues = Form.useWatch([], form);
  const isFormIncomplete =
    !formValues?.ifsc ||
    !formValues?.accountNumber ||
    !formValues?.accountHolderName;

  const handleSetBankCode = (code: string) => {
    setEnachBankCode(code);
  };
  const handleBranchName = (name: string) => {
    setBranckName(name);
  };

  const handleSubmit = () => {
    form
      .validateFields()
      .then((values: nachBankDetailType) => {
        // console.log('values ', values);
        // console.log('Mandate email', values);
        // console.log('mandateLinkData', mandateLinkData);

        const requestData: nachRequestType = {
          amount: 0,
          email: mandateLinkData.nachUserDetails.emailId,
          contact: mandateLinkData.nachUserDetails.mobileNumber,
          name: values.accountHolderName || mandateLinkData.nachUserDetails.customerName,
          mandateid: parseInt(mandateId),
          method: 'emandate',
          max_amount: mandateLinkData.maxBillingAmount,
          fail_existing: 0,
          expire_at: getTodayTo25YearsTimestamp(),
          nachtype: 'enach',
          bank_account: {
            beneficiary_name: values.accountHolderName || '',
            account_number: values.accountNumber || '',
            account_type: values.accountType || '',
            ifsc_code: values.ifsc || '',
          },
          bankName: values.bankName || '',
          bankCode: enachBankCode || '',
          branchName: branchName || '',
        };
        // console.log('razorpay enach setup ', requestData);

        setIsLoading(true);
        // debugger;
        razorpayNachSetup(requestData)
          .then((res) => {
            // console.log('razorpay enach ', res);
            if (res.status == 'SUCCESS' && res.data && res.data.custid && res.data.orderid) {
              const timerId = setTimeout(() => {
                // console.log('Order id', res.data?.orderid);
                // console.log('mandate id', mandateId);
                setIsLoading(true);

                const request: waitingRequestType = {
                  mandateId: parseInt(mandateId),
                  orderId: res.data?.orderid,
                };

                waitingRazorpayOrder(request)
                  .then((res) => {
                    // Handle response from waitingRazorpayOrder
                    setIsLoading(true);
                    navigate(customer_routes.success_page.to);
                    // console.log('Waiting Razorpay Order response:', res);
                    if (res) {
                      message.success('Waiting Razorpay api hit successfully ');
                    }
                    // Navigate to summary page or show a message based on the response
                  })
                  .catch((error) => {
                    console.error('Error in waitingRazorpayOrder:', error);
                    message.error('Error while processing the request.');
                  });
              }, 15 * 60000); // 15 minuts

              setPaymentTimeoutId(timerId);

              handlePayment({ cust_id: res.data.custid, id: res.data.orderid });
            } else {
              message.error('Failed to process');
            }
          })
          .finally(() => {
            setIsLoading(false);
          });
      })
      .catch((info) => {
        console.log('Validate Failed:', info);
      });
  };

  // console.log('Razorpay', Razorpay);

  const handlePayment = useCallback(
    (order: { id: string; cust_id: string }) => {
      const options: RazorpayOptions = {
        key: import.meta.env.VITE_RAZORPAY_KEY,
        order_id: order.id,
        customer_id: order.cust_id,
        recurring: true,
        currency: 'INR',
        // amount: mandateLinkData.mandateAmount + '',
        amount: '0',
        name: 'Avanse Corp',
        hidden: {
          contact: true,
          email: true,
        },
        handler: function (response) {
          // alert(response.razorpay_payment_id);
          if (paymentTimeoutId) {
            clearTimeout(paymentTimeoutId); // Clear the timer on successful payment
          }
          goToSummaryPage(response.razorpay_payment_id);
          // alert(response.razorpay_order_id);
          // alert(response.razorpay_signature);
        },
        // notes: {
        //   'note_key 1': 'Beam me up Scotty',
        //   'note_key 2': 'Tea. Earl Gray. Hot.',
        // },
        theme: {
          color: '#2c9897',
        },
      };

      console.log('Show Razorpay modal');

      const rzpay = new Razorpay(options);
      rzpay.open();
      console.log('Response received', rzpay);
    },

    [Razorpay]
  );
  const goToSummaryPage = (paymentId: string) => {
    // console.log(paymentId);

    navigate(customer_routes.nach_payment_summary.to, {
      state: { paymentId: paymentId, mandateId, nachType: 1 },
      replace: true,
    });
  };

  useEffect(() => {
    return () => {
      if (paymentTimeoutId) {
        clearTimeout(paymentTimeoutId); // Clear timeout on unmount
      }
    };
  }, [paymentTimeoutId]);

  return (
    <div style={{ marginTop: '60px' }}>
      <Loading isLoading={isLoading} />
      <NachWrapper title="E-NACH Bank Details">
        <BankDetails
          nachId={1}
          nachBankData={bankData as any}
          form={form}
          setEnachBankCode={handleSetBankCode}
          setBranckName={handleBranchName}
          sourceType="E-NACH" // <--- Add this line
        />
        <div style={{ marginTop: '7px', float: 'right', marginRight: '10px' }}>
          <Button type="primary"
            htmlType="button"
            // onClick={handleSubmit}
            onClick={handleSubmit}
            disabled={isFormIncomplete}

          >
            Proceed
          </Button>
        </div>
      </NachWrapper>
    </div>
  );
}

export default Enach;
